import useToken from "@shared/hooks/useToken";

function ProtectedRoute({ children }) {
  const { token } = useToken();

  return token ? children : null;
}

export default ProtectedRoute;
